import React, {useCallback, useRef} from 'react';
import {useSearch} from 'modules/Search/hooks';
import AddressSearchForm from "shared/AddressSearchForm";
import navRoute from "helper/navRoute";
import {ContentStyle} from "./styles";

const SearchField = ({}) => {
    const { input } = useSearch()
    const navigation = navRoute()
    const fieldRef = useRef(null)

    const onGo = useCallback(() => {
        navigation.back();
    }, [])


    /*useEffect(() => {
        handleSearch(query)
    }, [query])*/




    return (
        <ContentStyle data-cy={'search-field'}>
            <AddressSearchForm
                placeholder={'Найти блюдо'}
                rightButtonClick={onGo}
                forwardRef={fieldRef}
                input={input}
            />
        </ContentStyle>
    )
}


export default SearchField

//export default React.memo(SearchField);
